<template>
    <div>
        <!--APPLY BASIC STYLE VARIABLES, ACCESSIBLE FROM CSS.-->
        <component :is="isStyle" type="text/css">
        :root{
            --primary: {{primaryColor}};
            --text-color:{{textColor}};
            --opposite-text-color:oppositeTextColor;
            --r:{{hexToRgb['r']}}
            --g:{{hexToRgb['g']}}
            --b:{{hexToRgb['b']}}
        }
        </component>

        <div class="absolute-buttons">
            <div class="fixed-buttons">
                <button @click="searchModalBool=true" v-if="storeBool" class="button  m-t-10 main-nav-btns">
                    <p><i class="fas fa-search"></i></p>
                </button>
                <button v-if="storeBool" @click="goToCart" class="button m-t-10 main-nav-btns">
                    <span class="tag cart-count-span is-rounded is-danger">{{cartCount}}</span>
                    <i class="fas fa-shopping-bag "></i>
                </button>
                <button v-if="b2bBool && loggedUser" @click="goToNewOrder" class="button m-t-10 main-nav-btns">
                    <i class="fas fa-plus "></i>
                </button>

                <button 
                @click="openSidebar=false;userActionModal=true" 
                class="button m-t-10 main-nav-btns"
                :class="isFullSiteBool ? 'is-hidden-touch' : ''">
                    <i class="fas fa-user"></i>
                </button>
                <button v-if="isFullSiteBool" @click="userActionModal=false;openSidebar=true" class="is-hidden-desktop button m-t-10 main-nav-btns">
                    <i class="fas fa-bars"></i>
                </button>
            </div>
        </div>

        <!-- NAVBAR DE ESCRITORIO -->
        <Topbar
        v-if="isFullSiteBool"
        :loggedUser="loggedUser"
        :logoutUrl="logoutUrl"
        :registerUrl="registerUrl"
        :loginUrl="loginUrl"
        :userSettings="userSettings"
        :searchEndpoint="searchEndpoint"
        :searchResultsUrl="searchResultsUrl"
        :logo="logo"
        :categories="categories"
        :contactUrl="contactUrl"
        :cartDetail="cartDetail"
        :cartCount="cartCount"
        :storeNavStyle="storeNavStyle"
        :isStore="storeBool"
        :isContent="contentBool"
        :isB2b="b2bBool"
        :pedidos-url="pedidosUrl"
        :faqsBool="faqsBool"
        :faqsUrl="faqsUrl"
        :blogBool="blogBool"
        :blogUrl="blogUrl"
        :blogPowerUp="blogPowerUp"
        :navPages="navPages"
        :generalCatalogUrl="generalCatalogUrl"
        />

        <BasicSiteTopbar
        v-if="!isFullSiteBool"
        :logo="logo"
        :b2bBool="b2bBool"
        :faqsBool="faqsBool"
        :faqsUrl="faqsUrl"
        :blogBool="blogBool"
        :blogUrl="blogUrl"
        :contactUrl="contactUrl"
        :pedidosUrl="pedidosUrl"
        :loggedUser="loggedUser"
        :blogPowerUp="blogPowerUp"
        />

        <UserActionsModal
        :userActionModal="userActionModal"
        :loggedUser="loggedUser"
        :logoutUrl="logoutUrl"
        :loginUrl="loginUrl"
        :registerUrl="registerUrl"
        :userSettings="userSettings"
        @closeModal="userActionModal=false"/>

        <SearchModal
        :searchModalBool="searchModalBool"
        :searchEndpoint="searchEndpoint" 
        :searchResultsUrl="searchResultsUrl"
        @closeModal="searchModalBool=false"/>

        <SidebarMenu
        v-if="isFullSiteBool"
        :loggedUser="loggedUser"
        :logoutUrl="logoutUrl"
        :registerUrl="registerUrl"
        :loginUrl="loginUrl"
        :contactUrl="contactUrl"
        :userSettings="userSettings"
        :searchEndpoint="searchEndpoint"
        :searchResultsUrl="searchResultsUrl"
        :logo="logo"
        :openSidebar="openSidebar"
        :categories="categories"
        :isStore="storeBool"
        :isContent="contentBool"
        :isB2b="b2bBool"
        :faqsBool="faqsBool"
        :faqsUrl="faqsUrl"
        :blogBool="blogBool"
        :blogUrl="blogUrl"
        :navPages="navPages"
        @sidebarCloseEvent="openSidebar=false"
        />

        <b-notification class="is-top" type="is-info" has-icon :active.sync="completeProfilePopUp" aria-close-label="Close notification">
            <p>Completando tu perfil podes usar los datos en las ordenes, y no tenes que rellenarlos cada vez que compras algo.</p>
            <a v-if="!hideCallToActionBtn" class="has-text-centered button is-small is-rounded is-white" :href="userSettings">Ir a mi perfil</a>
        </b-notification>

        <b-notification class="is-top" type="is-info" has-icon :active.sync="getInPopUp" aria-close-label="Close notification">
            <p>Los usuarios pueden acceder a beneficios como <b>cupones de descuento exclusivos, perfiles de datos para ordenes y mas!.</b></p>
            <a class="has-text-centered button is-small is-rounded is-white is-outlined" :href="loginUrl">Iniciar sesion</a>
            <a class="has-text-centered button is-small is-rounded is-white" :href="registerUrl">Registrarme</a>
        </b-notification>

    </div>
</template>

<script>
import SearchModal from "./components/SearchModal"
import SidebarMenu from "./components/SidebarMenu"
import UserActionsModal from "./components/UserActionsModal"
import Topbar from "./components/Topbar"
import BasicSiteTopbar from "./components/BasicSiteTopbar"
import {debounce, getHandler} from "./../../../services/http.js"

export default {
    components:{
        SearchModal,
        SidebarMenu,
        Topbar,
        UserActionsModal,
        BasicSiteTopbar
    },
    props:{
        primaryColor:{
            type:String,
            default:""
        },
        logo:{
            type:String,
            default:""
        },
        categoriesUrl:{
            type:String,
            default:""
        },
        blackText:{
            type:String,
            default:""
        },
        cartDetail:{
            type:String,
            default:""
        },
        cartCount:{
            type:String,
            default:""
        },
        userIn:{
            type:String,
            default:""
        },
        logoutUrl:{
            type:String,
            default:""
        },
        loginUrl:{
            type:String,
            default:""
        },
        registerUrl:{
            type:String,
            default:""
        },
        userSettings:{
            type:String, 
            default:""
        },
        userEmailActive:{
            type: String,
            defaut:""
        },
        searchEndpoint:{
            type:String,
            default:""
        },
        searchResultsUrl:{
            type:String,
            default:""
        },
        contactUrl:{
            type:String,
            default:""
        },
        isStore:{
            type:String,
            default:""
        },
        isContent:{
            type:String,
            default:""
        },
        isB2b:{
            type:String,
            default:""
        },
        isFullSite:{
            type:String,
            default:""
        },
        pedidosUrl:{
            type:String,
            default:""
        },
        profileStreet:{
            type:String,
            default:""
        },
        profileRegion:{
            type:String,
            default:""
        },
        faqsFlag:{
            type:String,
            default:""
        },
        faqsUrl:{
            type:String,
            default:""
        },
        blogFlag:{
            type:String,
            default:""
        },
        blogUrl:{
            type:String,
            default:""
        },
        blogPowerUp:{
            type:String,
            default:""
        },
        pageListUrl:{
            type:String,
            default:""
        },
        generalCatalogUrl:{
            type:String,
            default:""
        }
    },
    data(){
        return{
            storeNavStyle:{
                'border-bottom': `5px solid ${this.primaryColor}`,
            },
            storeBottomNavStyle:{
                'border-top': `5px solid ${this.primaryColor}`,
                'color': `${this.primaryColor} !important`,
            },
            primaryColorVar:{
                '--primary': `${this.primaryColor}`
            },
            navPages:[],
            isStyle:"style",
            categoriesLoading: false,
            categories:[],
            userActionModal:false,
            searchModalBool:false,
            openSidebar:false,
            completeProfilePopUp:false,
            getInPopUp:false, 
            hideCallToActionBtn: false
        }
    },
    methods:{
        goToCart(){
            window.location.href = this.cartDetail
        },
        goToNewOrder(){
            window.location.href = this.pedidosUrl
        },
        async fetchCategories(){
            this.categoriesLoading = true
            let url = this.categoriesUrl + "?hide_empty=TRUE"
            this.categories = await getHandler(url, {error:false, success:false})
            this.categoriesLoading = false
        },

        async fetchPages(){
            this.navPages = await getHandler(this.pageListUrl, {error:false, success:false})
            console.log(this.navPages)
        },

        sizeHandler: debounce(function(){
            let w = window.innerWidth
            if (w<1023){
                this.topNavFixed = false
            } else{
                this.topNavFixed = true
            }
            if (w<768){
                localStorage.setItem("ismobile", true)
            } else{
                localStorage.setItem("ismobile", false)
            }
            localStorage.setItem("isfixed", this.topNavFixed)
        }, 200),

        hexToRgb(hex) {
            var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
            hex = hex.replace(shorthandRegex, function(m, r, g, b) {
                return r + r + g + g + b + b;
            });

            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } : null;
        },
    },
    computed:{
        isFullSiteBool(){
            return this.isFullSite == "True"
        },
        rgbPrimaryColor(){
            return this.hexToRgb(this.primaryColor)
        },
        textColor(){
            if(this.blackText=="True"){
                return '#000000'
            } return 'white'
        },
        oppositeTextColor(){
            if(this.blackText=="True"){
                return 'white'
            } return '#000000'
        },
        faqsBool(){
            return this.faqsFlag == "True"
        },
        blogBool(){
            return this.blogFlag == "True"
        },
        loggedUser(){
            return this.userIn =="True"
        },
        emailActive(){
            return this.userEmailActive == "True"
        },
        storeBool(){
            return this.isStore == "True"
        },
        contentBool(){
            return this.isBool == "True"
        },
        b2bBool(){
            return this.isB2b == "True"
        }
    },

    created() {
        this.fetchCategories()
        this.fetchPages()
        this.sizeHandler()
        localStorage.setItem("cartCount", this.cartCount)
        var location = window.location.pathname
        console.log(this.emailActive)
        var locationForProfilePopUp = location.includes("/catalog/product/detail/") || location.includes("/user/settings/") || location.includes("/cart/detail/")
        if (this.loggedUser && locationForProfilePopUp){
            if(!this.profileStreet.length || this.profileStreet == "None" || !this.profileRegion || this.profileRegion == "None"){
                this.completeProfilePopUp = true
            }
            if(location.includes("/user/settings/")){
                this.hideCallToActionBtn = true
            }
        } else if (!this.loggedUser){
            if (location.includes("/catalog/product/detail/") || location.includes("/order/steps/") || location.includes("/cart/detail/")){
                this.getInPopUp = true
            }

        }
    },

}
</script>

<style lang="scss" scoped>
.p-1{
    padding: 1rem;
}

.is-custom{
    background-color: var(--primary);
    color:var(--text-color) !important;
}

li:hover{
    color:var(--primary) !important;
}

.card-header{
    p{
        padding: 1px ;
        padding-left:10px;
    }
}

.category-nav{
    width: 700px;
    max-height: 500px;
    overflow-y: scroll;
    margin: 0px auto;
    z-index:900;
}

a.navbar-item:hover{
    color:var(--primary) !important;
}

a.navbar-item:active{
    color:var(--primary) !important;
}

a.navbar-item:focus{
    color:var(--primary) !important;
}


a.navbar-link:hover{
    color:var(--primary) !important;
}

a.navbar-link:active{
    color:var(--primary) !important;
}

a.navbar-link:focus{
    color:var(--primary) !important;
}
.navbar-brand{
    .icon{
        color:var(--primary) ;
    }
}
.navbar-end{
    .navbar-item{
        .navbar-link:hover{
            color:var(--primary) !important;
        }
    }
}
.is-block{
    color: red;
}

.cat-card{
    margin-bottom:5px;
    border:0px #fff solid !important;
    border-radius: 20px;
    box-shadow: 1px 2px 10px rgba(184, 184, 184, 0.45);
    .card-header{
        box-shadow: 0px 0px #fff;
        border:0px #fff solid !important;
    }
}

.absolute-buttons{
    position: sticky;
    height: auto;
    width: 100vw;
    z-index: 10;
}

.fixed-buttons{
    position: fixed;
    right: 30px;
    top:60px;
    z-index: 10;
}

.main-nav-btns{
    box-shadow: 1px 0px 5px 1px rgba(143, 142, 142, 0.6);
    border-radius: 100%;
    display: block;
    transition: all 300ms;
    color: var(--primary);
    height: 60px;
    width: 60px;
    line-height: 0px;
    font-size: 1.5rem;
}

.main-nav-btns:hover{
    background-color: var(--primary);
    color: var(--text-color) !important;
    i {
        color: var(--text-color) !important;
    }
}

.main-nav-btns{
    i{
        padding: 0;
        margin:0;
        position: relative;

    }
}

.cart-count-span{
    position:absolute;
    z-index: 11;
    bottom:9px;
    right:9px;
}

@media (max-width: 767px){
    .fixed-buttons{
        top:auto;
        bottom:10px;
        right: 0px;
        left: 0px;
        width: 100%;
        text-align: center;
    }
    .main-nav-btns{
        margin-right: 20px;
        margin-left: 20px;
        height: 50px;
        width: 50px;
        z-index: 100000;
        font-size: 1.2rem;
        display: inline-block;
    }
    .cart-count-span{

        position:absolute;
        z-index: 11;
        bottom:5px;
        right: 5px;
    }
}
@media (max-width: 320px){
    .main-nav-btns{
        z-index: 100000;
        margin-right: 15px;
        margin-left: 15px;
    }
    .cart-count-span{
        bottom:3px;
        right: 3px;
    }
}

</style>